export default __webpack_public_path__ + "static/media/TR10.20c7ef5c.webp";